import { withInlineVoidElement } from "../../utils";

// SPF inline of type "text" (e.g. a bold glossary term carrying data.href "#ch03glos14").
// BV renders its children in a bare relatively-positioned span - no link behaviour. It
// must be registered inline, or the forced Slate normalize deletes it with its text.
const NODE_TYPE = "text";

export default function InlineText() {
  const plugin = (editor: any) => {
    withInlineVoidElement(editor, NODE_TYPE);
    return editor;
  };

  plugin.renderElement = ({ element, attributes, children }: any) => {
    if (element.type !== NODE_TYPE) {
      return undefined;
    }

    return (
      <span {...attributes} style={{ position: "relative" }}>
        {children}
      </span>
    );
  };

  return plugin;
}
